export default "__VITE_ASSET__CEEHrKp5__"